import * as React from 'react';
import { useSelector } from 'react-redux';

import { currentChatActiveReplyMessageIdSelector } from '../../../selectors';

type TUseScrollOnActiveReplyPreviewParams = {
  messageId: string;
  messageRef: React.RefObject<HTMLDivElement | null>;
};

/**
 * Если превью цитаты перегораживает сообщение, подскролливаем его во viewport
 */
export const useScrollOnActiveReplyPreview = ({ messageId, messageRef }: TUseScrollOnActiveReplyPreviewParams) => {
  const activeReplyMessageId = useSelector(currentChatActiveReplyMessageIdSelector);

  React.useLayoutEffect(() => {
    if (activeReplyMessageId !== messageId) {
      return;
    }

    messageRef.current?.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
  }, [activeReplyMessageId, messageId, messageRef]);
};
